import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../services/api';

const SuperProfilePage = () => {
  const { user, refreshUser } = useAuth();

  const [infoForm,    setInfoForm]    = useState({ name: user?.name || '', phone: user?.phone || '' });
  const [infoSaving,  setInfoSaving]  = useState(false);
  const [infoSuccess, setInfoSuccess] = useState('');
  const [infoError,   setInfoError]   = useState('');

  const [emailForm,    setEmailForm]    = useState({ newEmail: '', password: '' });
  const [emailSaving,  setEmailSaving]  = useState(false);
  const [emailSuccess, setEmailSuccess] = useState('');
  const [emailError,   setEmailError]   = useState('');

  const [pwdForm,    setPwdForm]    = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [pwdSaving,  setPwdSaving]  = useState(false);
  const [pwdSuccess, setPwdSuccess] = useState('');
  const [pwdError,   setPwdError]   = useState('');
  const [showPwd,    setShowPwd]    = useState(false);

  const saveInfo = async (e) => {
    e.preventDefault();
    setInfoError(''); setInfoSuccess('');
    setInfoSaving(true);
    try {
      await authAPI.updateProfile({ name: infoForm.name, phone: infoForm.phone });
      await refreshUser();
      setInfoSuccess('تم حفظ البيانات بنجاح');
    } catch (err) {
      setInfoError(err?.response?.data?.message || 'خطأ في الحفظ');
    } finally { setInfoSaving(false); }
  };

  const changeEmail = async (e) => {
    e.preventDefault();
    setEmailError(''); setEmailSuccess('');
    if (!emailForm.newEmail || !emailForm.password) {
      setEmailError('أدخل البريد الإلكتروني الجديد وكلمة المرور');
      return;
    }
    setEmailSaving(true);
    try {
      await authAPI.changeEmail({ newEmail: emailForm.newEmail, password: emailForm.password });
      setEmailSuccess('تم إرسال رابط تأكيد إلى البريد الإلكتروني الجديد. لن يتم تحديث بريدك حتى تفتح الرابط وتؤكده.');
      setEmailForm({ newEmail: '', password: '' });
    } catch (err) {
      setEmailError(err?.response?.data?.message || 'خطأ في تحديث البريد الإلكتروني');
    } finally { setEmailSaving(false); }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    setPwdError(''); setPwdSuccess('');
    if (pwdForm.newPassword !== pwdForm.confirmPassword) {
      setPwdError('كلمتا المرور الجديدتان غير متطابقتين');
      return;
    }
    if (pwdForm.newPassword.length < 8) {
      setPwdError('كلمة المرور الجديدة يجب أن تكون 8 أحرف على الأقل');
      return;
    }
    setPwdSaving(true);
    try {
      await authAPI.changePassword({ currentPassword: pwdForm.currentPassword, newPassword: pwdForm.newPassword });
      setPwdSuccess('تم تغيير كلمة المرور بنجاح');
      setPwdForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      setPwdError(err?.response?.data?.message || 'خطأ في تغيير كلمة المرور');
    } finally { setPwdSaving(false); }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto space-y-6" dir="rtl">
      <div>
        <h1 className="text-2xl font-black text-gray-900">الملف الشخصي</h1>
        <p className="text-sm text-gray-500 mt-0.5">بيانات حساب المدير العام</p>
      </div>

      {/* Account info card */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
        {/* Avatar row */}
        <div className="flex items-center gap-4 mb-6 pb-6 border-b border-gray-100">
          <div className="w-16 h-16 rounded-2xl bg-yellow-500 flex items-center justify-center text-gray-900 text-2xl font-black flex-shrink-0">
            {(user?.name || '؟').split(' ').slice(0, 2).map(w => w[0]).join('')}
          </div>
          <div>
            <p className="text-lg font-bold text-gray-900">{user?.name}</p>
            <p className="text-sm text-yellow-600 font-semibold">مدير عام</p>
            <p className="text-xs text-gray-400 mt-0.5">{user?.email}</p>
          </div>
        </div>

        {/* Read-only fields */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wide mb-1">البريد الإلكتروني</label>
            <p className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700" dir="ltr">{user?.email}</p>
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wide mb-1">الدور</label>
            <p className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700">مدير عام (Super Admin)</p>
          </div>
        </div>

        {/* Editable info */}
        <form onSubmit={saveInfo} className="space-y-4">
          <h3 className="text-sm font-bold text-gray-700">تعديل البيانات</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-gray-500 mb-1">الاسم الكامل</label>
              <input
                value={infoForm.name}
                onChange={e => setInfoForm(f => ({ ...f, name: e.target.value }))}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 mb-1">رقم الهاتف</label>
              <input
                value={infoForm.phone}
                onChange={e => setInfoForm(f => ({ ...f, phone: e.target.value }))}
                dir="ltr"
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
              />
            </div>
          </div>
          {infoError   && <p className="text-red-600 text-sm">{infoError}</p>}
          {infoSuccess && <p className="text-green-600 text-sm font-semibold">✓ {infoSuccess}</p>}
          <button
            type="submit"
            disabled={infoSaving}
            className="bg-yellow-500 hover:bg-yellow-400 disabled:opacity-60 text-gray-900 font-bold px-6 py-2.5 rounded-xl text-sm transition-colors"
          >
            {infoSaving ? 'جاري الحفظ...' : 'حفظ التغييرات'}
          </button>
        </form>
      </div>

      {/* Change email card */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
        <h3 className="text-base font-bold text-gray-800 mb-1">تغيير البريد الإلكتروني</h3>
        <p className="text-xs text-gray-400 mb-4">البريد الحالي: <span dir="ltr">{user?.email}</span></p>
        <form onSubmit={changeEmail} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-500 mb-1">البريد الإلكتروني الجديد</label>
            <input
              type="email"
              value={emailForm.newEmail}
              onChange={e => setEmailForm(f => ({ ...f, newEmail: e.target.value }))}
              dir="ltr"
              placeholder="example@domain.com"
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 mb-1">كلمة المرور الحالية (للتحقق)</label>
            <input
              type="password"
              value={emailForm.password}
              onChange={e => setEmailForm(f => ({ ...f, password: e.target.value }))}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
          </div>
          {emailError   && <p className="text-red-600 text-sm">{emailError}</p>}
          {emailSuccess && <p className="text-green-600 text-sm font-semibold">✓ {emailSuccess}</p>}
          <button
            type="submit"
            disabled={emailSaving}
            className="bg-yellow-500 hover:bg-yellow-400 disabled:opacity-60 text-gray-900 font-bold px-6 py-2.5 rounded-xl text-sm transition-colors"
          >
            {emailSaving ? 'جاري التحديث...' : 'تحديث البريد الإلكتروني'}
          </button>
        </form>
      </div>

      {/* Change password card */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
        <h3 className="text-base font-bold text-gray-800 mb-4">تغيير كلمة المرور</h3>
        <form onSubmit={changePassword} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-500 mb-1">كلمة المرور الحالية</label>
            <input
              type={showPwd ? 'text' : 'password'}
              value={pwdForm.currentPassword}
              onChange={e => setPwdForm(f => ({ ...f, currentPassword: e.target.value }))}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-gray-500 mb-1">كلمة المرور الجديدة</label>
              <input
                type={showPwd ? 'text' : 'password'}
                value={pwdForm.newPassword}
                onChange={e => setPwdForm(f => ({ ...f, newPassword: e.target.value }))}
                placeholder="8 أحرف على الأقل"
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 mb-1">تأكيد كلمة المرور الجديدة</label>
              <input
                type={showPwd ? 'text' : 'password'}
                value={pwdForm.confirmPassword}
                onChange={e => setPwdForm(f => ({ ...f, confirmPassword: e.target.value }))}
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
              />
            </div>
          </div>
          <label className="flex items-center gap-2 text-sm text-gray-500 cursor-pointer w-fit">
            <input type="checkbox" checked={showPwd} onChange={e => setShowPwd(e.target.checked)} className="rounded" />
            إظهار كلمات المرور
          </label>
          {pwdError   && <p className="text-red-600 text-sm">{pwdError}</p>}
          {pwdSuccess && <p className="text-green-600 text-sm font-semibold">✓ {pwdSuccess}</p>}
          <button
            type="submit"
            disabled={pwdSaving}
            className="bg-gray-800 hover:bg-gray-700 disabled:opacity-60 text-white font-bold px-6 py-2.5 rounded-xl text-sm transition-colors"
          >
            {pwdSaving ? 'جاري التغيير...' : 'تغيير كلمة المرور'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SuperProfilePage;
